import React from "react";

const defaultRender = () => null;

const check = (
  accessPermissions,
  actions = [],
  condition = true,
  toggleOn = true
) => {
  if (!accessPermissions || !condition || !toggleOn) {
    return false;
  }

  return (
    actions.length === 0 ||
    actions.some((action) => Object.hasOwn(accessPermissions, action))
  );
};

const HasPermissionTo = React.forwardRef(
  (
    {
      permissions = null,
      perform = [],
      condition = true,
      toggleOn = true,
      render = defaultRender,
      noRender = defaultRender,
    },
    ref
  ) =>
    check(permissions, perform, condition, toggleOn)
      ? render(ref)
      : noRender(ref)
);

HasPermissionTo.displayName = "HasPermissionTo";

// Same check as the component, for callers that need the result rather than a render.
export const hasPermissionTo = check;

export default HasPermissionTo;
